import type { NewsArticle } from "@/content/types";

const modules = import.meta.glob<{ article: NewsArticle }>("./*.ts", { eager: true });

/** Alle nieuwsartikelen, nieuwste eerst. */
export const NEWS_ARTICLES: NewsArticle[] = Object.values(modules)
  .filter((m) => Boolean(m?.article))
  .map((m) => m.article)
  .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));

export function newsPath(a: Pick<NewsArticle, "slug">): string {
  return `/nieuws/${a.slug}`;
}

export function getNewsArticle(slug: string): NewsArticle | null {
  return NEWS_ARTICLES.find((a) => a.slug === slug) ?? null;
}

export function newsWordCount(article: NewsArticle): number {
  let words = 0;
  for (const block of article.blocks) {
    if ("text" in block && block.text) words += block.text.split(/\s+/).length;
    if ("items" in block) words += block.items.join(" ").split(/\s+/).length;
    if (block.type === "table") words += block.rows.flat().join(" ").split(/\s+/).length;
  }
  return words;
}
